import React from 'react';
import * as styles from './styles.scss';

const Container = ({ className, children }) => (
    <div className={`${styles.container}${className ? ` ${className}` : ''}`}>
        {children}
    </div>
);

export default Container;
